import { IconDefinition } from '@ant-design/icons-angular';

export const LayoutTwoTone: IconDefinition = {
    name: 'layout',
    theme: 'twotone',
    icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z" fill="#E6E6E6" /><path d="M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z" fill="#333" /></svg>'
}